import React from "react"
import { motion } from 'framer-motion'
import { useStaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/layout/Layout"
import Header from "../components/layout/Header"
import Footer from "../components/layout/Footer"
import Components from "../components/content/Components"

const ContactPage = ({ data }) => {

  const privacy = data.strapiPrivacy
  const components = privacy.components

  return (
    <Layout>
      <Header />
        <Components components={components || []} />
      <Footer />
    </Layout>
  )
}

export const pageQuery = graphql`
  {
    strapiPrivacy(locale: {eq: "en"}) {
      title
      description
      slug
      localizations {
        slug
      }
      components {
        __typename
        ... on StrapiComponentContentRichTexts {
          id
          RichMargins
          Text
          strapiId
        }
        ... on StrapiComponentContentStickyMedia {
          Direction
          Headline
          Text
          strapiId
          portraitMode
          captionText
          Media {
            alternativeText
            caption
            mime
            name
            url
            file {
              childImageSharp {
                gatsbyImageData(quality:75, placeholder: DOMINANT_COLOR)
              }
              name
              url
            }
          }
        }
        ... on StrapiComponentContentStickyText {
          id
          Headline
          Text
          strapiId
        }
        ... on StrapiComponentImagesGalery {
          strapiId
          portraitMode
          GaleryEntries {
            Headline
            Subheadline
            Text
            id
            strapiId
            Media {
              caption
              alternativeText
              mime
              name
              url
              file {
                childImageSharp {
                  gatsbyImageData(quality:75, placeholder: DOMINANT_COLOR)
                }
                name
                url
              }
            }
          }
        }
        ... on StrapiComponentImagesImage {
          ImageMargins
          ImageSize
          LinkTarget
          LinkURL
          strapiId
          captionText
          portraitMode
          Media {
            alternativeText
            caption
            mime
            file {
              childImageSharp {
                gatsbyImageData(quality:75, layout: FULL_WIDTH, placeholder: DOMINANT_COLOR)
              }
              name
              url
            }
          }
        }
        ... on StrapiComponentImagesStages {
          Headlinecolor
          Layout
          Subheadline
          Text
          strapiId
          captionText
          Media {
            alternativeText
            caption
            mime
            name
            url
            file {
              childImageSharp {
                gatsbyImageData(quality:75, aspectRatio: 1.7, layout: FULL_WIDTH, placeholder: DOMINANT_COLOR)
              }
              name
              url
            }
          }
        }
        ... on StrapiComponentLinksDownloads {
          id
          Text
          strapiId
          Downloads {
            Name
            id
            strapiId
            Download {
              alternativeText
              caption
              mime
              name
              url
              file {
                url
              }
            }
          }
        }
        ... on StrapiComponentLinksLinkList {
          id
          strapiId
          Links {
            LinkTargets
            LinkURL
            Title
            id
            strapiId
          }
        }
      }
    }
  }
`

export default ContactPage


export function Head({ data }) {

  const meta = data.strapiPrivacy

  const seo = {
    metaDescription: meta.description,
    siteName: meta.title,
  }

  return (
    <>
      <body className="privacy" />
      <title>{`${seo.siteName} — Allianz Foundation`}</title>
      <meta name="description" content={`${seo.metaDescription}`} />
      <meta name="image" content={`${seo.imageUrl}`} />
      <meta property="og:title" content={`${seo.siteName}`} />
      <meta property="og:description" content={`${seo.metaDescription}`} />
      <meta property="og:image" content={`${seo.imageUrl}`} />
      <meta name="twitter:title" content={`${seo.siteName}`} />
      <meta name="twitter:description" content={`${seo.metaDescription}`} />
      <meta name="twitter:image" content={`${seo.imageUrl}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="robots" content="index,follow" />
      <meta name="googlebot" content="index,follow" />
    </>
  )
}
